import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from '@library';
import HorizontalLayout from '../../../core/components/layout/HorizontalLayout';
import styles from './ProductTile.module.scss';

const ProductTileSKUInfo = ({ activeSKU }: { activeSKU?: string }) => {
    return (
        <div className={styles.activeSku}>
            <HorizontalLayout>
                <Text tertiary medium>
                    <FormattedMessage id="Common ItemNumber" />
                    :&nbsp;
                </Text>
                <Text
                    tertiary
                    uppercase={!!activeSKU}
                    data-test-class="productSku"
                >
                    {activeSKU || (
                        <FormattedMessage id="please make a choice" />
                    )}
                </Text>
            </HorizontalLayout>
        </div>
    );
};

export default memo(ProductTileSKUInfo);
